// SPDX-License-Identifier: AGPL-3.0-or-later
import styles from '@app/features/gift/components/SubscriptionGiftCard.module.css';
import giftArtwork from '@app/media/images/raven-plus-gift-v3.png';
import type {ReactNode} from 'react';
interface SubscriptionGiftCardProps { title:ReactNode; duration:ReactNode; sender?:ReactNode; status?:ReactNode; footer:ReactNode; redeemed?:boolean; }
export function SubscriptionGiftCard({title,duration,sender,status,footer,redeemed=false}:SubscriptionGiftCardProps) {
 return <div className={styles.frame}><section className={styles.card} data-redeemed={redeemed} data-flx="gift.subscription-gift-card">
  <div className={styles.content}>
   <h3 className={styles.title}>{title}</h3>
   {sender && <div className={styles.sender}>{sender}</div>}
   <div className={styles.duration}>{duration}</div>
   {status && <div className={styles.status}>{status}</div>}
   <div className={styles.footer}>{footer}</div>
  </div>
  <div className={styles.artwork}><img src={giftArtwork} alt="" aria-hidden="true" draggable={false} /></div>
 </section></div>;
}
